import { FC } from 'react';
import { Field, Form } from 'react-final-form';
import { useUpdateLoanOfferStatus } from '../../../hooks/loan/useUpdateLoanOfferStatus';
import { LoanOffer, LoanOfferStatus } from '../../../interfaces';
import LoadingIndicator from '../../Common/LoadingIndicator';
import Modal from '../../Common/Modal';

type Props = {
  loanOffer: LoanOffer;
};

const AcceptLoanOffer: FC<Props> = ({ loanOffer }) => {
  const { onSubmitHandler, updating, showForm, toggleForm } = useUpdateLoanOfferStatus(loanOffer, LoanOfferStatus.ACCEPTED);
  return (
    <>
      <button onClick={toggleForm} className='btn btn-sm btn-light-primary me-3'>
        Accept
      </button>

      <Modal show={showForm} toggle={toggleForm} title='Accept Offer'>
        <Form
          onSubmit={onSubmitHandler}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className='mb-5'>
                <label className='form-label fs-7'>Send a note to the investor</label>
                <Field name='note' type='textarea'>
                  {({ input }) => <textarea {...input} name='note' className='form-control form-control-lg form-control-solid'></textarea>}
                </Field>
              </div>

              <div className='mt-10'>
                <button type='submit' disabled={updating} className='btn btn-sm btn-primary me-3 ms-auto'>
                  {updating ? <LoadingIndicator /> : 'Accept Loan Offer'}
                </button>
              </div>
            </form>
          )}
        />
      </Modal>
    </>
  );
};

export default AcceptLoanOffer;
